// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".mu8-main-content {\n  border: 1px solid #e9e9e9;\n  padding: 30px;\n}\n", "",{"version":3,"sources":["webpack://./src/yinghai/cms/css/page.less"],"names":[],"mappings":"AAAA;EACI,yBAAA;EACA,aAAA;AACJ","sourcesContent":[".mu8-main-content{\n    border: 1px solid #e9e9e9;\n    padding: 30px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
